import { createModel } from '@/store/tools';

const model = {
    namespace: 'systemOperation',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getSystemOperationInfo': T('getSystemOperationInfo'),
        },
        actions: {
            'getSystemOperationInfo': A('getSystemOperationInfo'),
        },
        sagas: {
            'getSystemOperationInfo': S('getSystemOperationInfo', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.infoCompanyByCompanyAccount'),
        },
        reducers: {
            'systemOperationInfo': R('getSystemOperationInfo', {}),
        }
    })
};
export default createModel(model);